import { Modal } from "antd";
import { useEffect, useRef } from "react";
import { NavigationType, useLocation, useNavigationType } from "react-router-dom";

/**
 * Closes AntD's static dialogs (Modal.confirm/warning/success/info/error, so
 * every showConfirmModal / showDestructiveConfirm and the like) when the admin
 * leaves the page they were opened on.
 *
 * A component Modal unmounts with its page. A static one renders in its own
 * React root outside the router, so it outlived the page: pressing Back with
 * one open left it on top of the previous page with its confirm button still
 * live, acting on the record the admin had just left (a *Buat Kode Baru* left
 * over on the Klien list still rotated the previous client's code).
 *
 * Fires on Back/Forward, and on any navigation to another path. A same-path
 * replace (a tab or filter written to the URL) leaves an open dialog alone.
 * The dialog's own dismiss handler does not run: its page is gone, and a
 * handler that reopens a modal it hid (showDestructiveConfirm's onCancel)
 * must not reopen it on the page the admin went to.
 *
 * Mounted once, at the router root, so it covers every layout.
 */
export const useCloseStaticModalsOnNavigation = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previous = useRef(location);

  useEffect(() => {
    const before = previous.current;
    previous.current = location;
    if (before.key === location.key) return;
    if (navigationType === NavigationType.Pop || before.pathname !== location.pathname) {
      Modal.destroyAll();
    }
  }, [location, navigationType]);
};
